module.exports = __webpack_public_path__ + "static/media/iv_down.d279c460.svg";